import React, { Component } from 'react';

class IconPeople extends Component {
    render() {
        return (
            <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26"><path className="a" d="M15.119,18.708A5.418,5.418,0,1,0,9.6,13.292,5.483,5.483,0,0,0,15.119,18.708Zm0,3.972C10.8,22.681,2.25,24.757,2.25,29v4.875h26V29C28.25,24.757,19.439,22.681,15.119,22.681Z" transform="translate(-2.25 -7.875)" fill="#ccc" /></svg>
        );
    }
}

export default IconPeople;